function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { createContext, useContext } from "react";
export var CONTEXT_VERSION = 1;
export function createLeafletContext(map) {
    return Object.freeze({
        __version: CONTEXT_VERSION,
        map: map
    });
}
export function extendContext(source, extra) {
    return Object.freeze(_objectSpread({}, source, extra));
}
export var LeafletContext = createContext(null);
export var LeafletProvider = LeafletContext.Provider;
export function useLeafletContext() {
    var context = useContext(LeafletContext);
    if (context == null) {
        throw new Error("No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>");
    }
    return context;
}
